import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { toHours } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import PermittedItems from '../Modules/PermittedItems';
import ProctorTypeList from '../Modules/ProctorTypeList';

const ConfirmExam = observer(class ConfirmExam extends React.Component {
  render() {
    const { translation } = this.props;
    const { exam, examAttachments, examFiles } = this.props.store.ExamStore;
    const { userTimezone } = this.props.store.SessionStore;
    let importedLmsExam = this.props.store.ExamStore.importedLmsExam;

    if(!importedLmsExam) {
      importedLmsExam = {};
    }

    let configuration = exam.configuration;

    if(this.props.customConfiguration) {
      configuration = this.props.customConfiguration;
    }

    let scheduleWindow = false;

    if(configuration.scheduleOpenDate || configuration.scheduleCloseDate) {
      if(
        moment(configuration.scheduleOpenDate).format('M-D-YYYY') !== '1-1-2000' ||
        moment(configuration.scheduleCloseDate).format('M-D-YYYY') !== '1-1-2070'
      ) {
        scheduleWindow = true;
      }
    }

    return(
      <div>
        <ul className="data--alt data--striped">
          <li>
            <strong>{translation.exam_name}</strong>
            <p>{importedLmsExam.title || exam.title}</p>
          </li>
          {/* Description isn't used at all */}
          {/* {(importedLmsExam.description || exam.description) &&
            <li>
              <strong>{translation.description}</strong>
              <p>{importedLmsExam.description || exam.description}</p>
            </li>
          } */}
          <li>
            <strong>{translation.duration}</strong>
            {importedLmsExam.duration &&
              <p>{toHours(importedLmsExam.duration, false, false, true)}</p>
            }

            {!importedLmsExam.duration &&
              <p>{toHours(configuration.duration, false, false, true)}</p>
            }
          </li>

          {exam.type.toLowerCase() !== 'written' &&
            <li>
              <strong>{translation.password}</strong>
              <p>{importedLmsExam.password || configuration.password}</p>
            </li>
          }

          {exam.type.toLowerCase() !== 'written' &&
            <li>
              <strong>{translation.url}</strong>
              <p>{importedLmsExam.examUrl || exam.url}</p>
            </li>
          }

          <li>
            <strong>{translation.attempts}</strong>
            <p>{importedLmsExam.attemptsAllowed || configuration.attempts}</p>
          </li>
          <li>
            <strong>{translation.exam_opens}</strong>

            {importedLmsExam.examOpenDate &&
              <p>
                {moment.utc(importedLmsExam.examOpenDate)
                       .tz(userTimezone)
                       .format('M/D/YYYY [at] h:mma z')}
              </p>
            }

            {!importedLmsExam.examOpenDate &&
              <p>
                {moment.utc(configuration.examOpenDate)
                       .tz(userTimezone)
                       .format('M/D/YYYY [at] h:mma z')}
              </p>
            }
          </li>
          <li>
            <strong>{translation.exam_closes}</strong>

            {importedLmsExam.examCloseDate &&
              <p>
                {moment.utc(importedLmsExam.examCloseDate)
                       .tz(userTimezone)
                       .format('M/D/YYYY [at] h:mma z')}
              </p>
            }

            {!importedLmsExam.examCloseDate &&
              <p>
                {moment.utc(configuration.examCloseDate)
                       .tz(userTimezone)
                       .format('M/D/YYYY [at] h:mma z')}
              </p>
            }
          </li>
          {scheduleWindow &&
            <li>
              <strong>{translation.scheduling_opens}</strong>
              <p>
                {moment.utc(configuration.scheduleOpenDate)
                       .tz(userTimezone)
                       .format('M/D/YYYY [at] h:mma z')}
              </p>
            </li>
          }
          {scheduleWindow &&
            <li>
              <strong>{translation.scheduling_closes}</strong>
              <p>
                {moment.utc(configuration.scheduleCloseDate)
                       .tz(userTimezone)
                       .format('M/D/YYYY [at] h:mma z')}
              </p>
            </li>
          }

          {exam.type.toLowerCase() !== 'written' && (examAttachments || (configuration.attachments && configuration.attachments.length > 0)) &&
            <li>
              <strong>{translation.attachments}</strong>
              <ul key={1} className="data--comma">
                {configuration.attachments && configuration.attachments.map(
                  (file, i) =>
                  <li key={i}>{file.attachmentAwsTitle}</li>
                )}
                {examAttachments && examAttachments.map(
                  (file, i) =>
                  <li key={i}>{file.name}</li>
                )}
              </ul>
            </li>
          }

          {exam.type.toLowerCase() === 'written' && (examFiles || (configuration.examFiles && configuration.examFiles.length > 0)) &&
            <li>
              <strong>{translation.exam_file}</strong>
              <ul key={1} className="data--comma">
                {configuration.examFiles && configuration.examFiles.map(
                  (file, i) =>
                  <li key={i}>{file.attachmentAwsTitle}</li>
                )}
                {examFiles && examFiles.map(
                  (file, i) =>
                  <li key={i}>{file.name}</li>
                )}
              </ul>
            </li>
          }

          <PermittedItems
            configuration={configuration}
            listItem={true}
            compact={true}
            {...this.props}
          />

          {configuration.studentNotes &&
            <li>
              <strong>{translation.student_notes}</strong>
              <p>{configuration.studentNotes}</p>
            </li>
          }

          {configuration.proctorNotes &&
            <li>
              <strong>{translation.proctor_notes}</strong>
              <p>{configuration.proctorNotes}</p>
            </li>
          }

          {configuration.proctorTypes.length > 0 &&
            <li>
              <strong>{translation.proctor_types}</strong>
              <ProctorTypeList
                proctorTypes={configuration.proctorTypes}
                {...this.props}
              />
            </li>
          }
        </ul>
      </div>
    );
  }
})

export default translate('ConfirmExam')(ConfirmExam);



// WEBPACK FOOTER //
// ./src/app/components/ExamEdit/ConfirmExam.js